/**
 * Preparación Imbatible - Animaciones Avanzadas
 * Optimizado: Slide-up effect + Faster Triggers + Staggered New Elements
 */

class PreparacionAnimations {
    constructor() {
        this.collageItems = document.querySelectorAll('.collage-item');
        this.preparacionTitle = document.querySelector('.preparacion-title');
        this.preparacionDescription = document.querySelector('.preparacion-description');
        this.accentLine = document.querySelector('.accent-line');
        this.badgesGrid = document.querySelector('.tech-badges-grid');
        this.ctaContainer = document.querySelector('.slide-up-init a.btn-cyber')?.parentElement; // The div wrapping the link

        this.section = document.querySelector('.preparacion-imbatible');
        this.hasTriggered = false;

        this.init();
    }

    init() {
        if (!this.section) {
            console.log('Preparación section not found');
            return;
        }

        // Apply initial states
        this.applyInitialStates();
        this.setupIntersectionObserver();
        this.setupMagneticEffect();
    }

    applyInitialStates() {
        // Init Collage Items
        this.collageItems.forEach(item => {
            item.classList.add('slide-up-init');
        });

        // Init Title
        if (this.preparacionTitle) this.preparacionTitle.classList.add('slide-up-init');

        // Init Description (already has class in HTML likely, but ensuring)
        if (this.preparacionDescription) this.preparacionDescription.classList.add('slide-up-init');

        // New Elements (already have class in HTML, but good to be safe)
        if (this.accentLine) this.accentLine.classList.add('slide-up-init');
        if (this.badgesGrid) this.badgesGrid.classList.add('slide-up-init');
        if (this.ctaContainer) this.ctaContainer.classList.add('slide-up-init');
    }

    setupIntersectionObserver() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.hasTriggered) {
                    this.hasTriggered = true;
                    this.startAnimationSequence();
                }
            });
        }, options);

        observer.observe(this.section);
    }

    startAnimationSequence() {
        // Fase 1: Collage (0ms - 300ms)
        this.collageItems.forEach((item, index) => {
            setTimeout(() => {
                item.classList.add('slide-up-active');
            }, index * 100);
        });

        // Fase 2: Título (200ms)
        setTimeout(() => {
            if (this.preparacionTitle) {
                this.preparacionTitle.classList.add('slide-up-active');
                this.preparacionTitle.classList.add('typewriter-active');
                setTimeout(() => {
                    this.preparacionTitle.style.borderRight = 'none';
                }, 1000);
            }
        }, 200);

        // Fase 3: Accent Line (300ms)
        setTimeout(() => {
            if (this.accentLine) this.accentLine.classList.add('slide-up-active');
        }, 300);

        // Fase 4: Descripción (400ms)
        setTimeout(() => {
            if (this.preparacionDescription) this.preparacionDescription.classList.add('slide-up-active');
        }, 400);

        // Fase 5: Badges (500ms)
        setTimeout(() => {
            if (this.badgesGrid) this.badgesGrid.classList.add('slide-up-active');
        }, 500);

        // Fase 6: CTA (600ms)
        setTimeout(() => {
            if (this.ctaContainer) this.ctaContainer.classList.add('slide-up-active');
        }, 600);
    }

    setupMagneticEffect() {
        if (!this.section) return;

        this.section.addEventListener('mousemove', (e) => {
            const { clientX, clientY } = e;
            const { innerWidth, innerHeight } = window;

            // Calculate mouse position relative to center (-1 to 1)
            const xPos = (clientX / innerWidth - 0.5) * 2;
            const yPos = (clientY / innerHeight - 0.5) * 2;

            this.collageItems.forEach((item, index) => {
                // Different intensity for each item for depth perception
                const intensity = (index + 1) * 10;
                const xOffset = xPos * intensity;
                const yOffset = yPos * intensity;

                // Apply transform without overwriting existing transforms (if any)
                // Note: slide-up uses transform, so we need to be careful. 
                // However, slide-up finishes and removes transform or sets it to translate(0).
                // Better approach: Apply to the IMG inside, not the item itself which has slide-up transition
                const img = item.querySelector('img');
                if (img) {
                    img.style.transform = `translate(${xOffset}px, ${yOffset}px) scale(1.05)`;
                    img.style.transition = 'transform 0.1s ease-out';
                }
            });
        });

        // Reset on mouse leave
        this.section.addEventListener('mouseleave', () => {
            this.collageItems.forEach(item => {
                const img = item.querySelector('img');
                if (img) {
                    img.style.transform = 'translate(0, 0) scale(1)';
                    img.style.transition = 'transform 0.5s ease-out';
                }
            });
        });
    }
}

// Inicialización
function initPreparacionAnimations() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            new PreparacionAnimations();
        });
    } else {
        new PreparacionAnimations();
    }
}

// Soporte para navegación Turbo
document.addEventListener('DOMContentLoaded', initPreparacionAnimations);
document.addEventListener('turbo:load', initPreparacionAnimations);
document.addEventListener('turbo:render', initPreparacionAnimations);

if (typeof module !== 'undefined' && module.exports) {
    module.exports = PreparacionAnimations;
}